module.exports = __webpack_public_path__ + "img/software-thumb-2-mod.ea0c9117.png";